import styled from 'styled-components';

export const Container = styled.div`
  height: 700px;
  margin: 0 -15px;
    .forum-iframe {
      border: none;
    }
`;